import * as types from '../constants/ActionTypes';

export function setSampleLang(lang) {
  return {
    type: types.SET_SAMPLE_LANG,
    lang
  };
}



/** WEBPACK FOOTER **
 ** ./src/js/actions/SampleActions.js
 **/